/**
 * settings/Configurator domain (agency branding/pricing-page config, quotes,
 * FAQ, help centre) - built on apiClient via useRequest, not useAppServices().
 * All of these save through the same generic PUT /agency the rest of the app
 * already uses (queries/agency.js's useUpdateAgency) - this one extra hook
 * exists only because Category.js/Configurator/index.js also need the
 * "categories" resource invalidated alongside "agency" (categories live on
 * the agency doc but are read by key ["categories"] elsewhere), which
 * agency.js's generic hook doesn't do. Shared by:
 *   - BasicInfo/BrandingTabs/AccountactivationQoute.js
 *   - BasicInfo/BrandingTabs/Category.js
 *   - FAQ/index.js, HelpCentre/index.js
 *   - Configurator/index.js
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useRequest from "hook/useRequest";
import { ReqMethods } from "enums";

const { PUT } = ReqMethods;

export function useUpdateAgencyConfig(toaster = true) {
  const request = useRequest();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => request(PUT, "/agency", { payload, toaster }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["agency"] });
      queryClient.invalidateQueries({ queryKey: ["categories"] });
    },
  });
}
